// @ts-check

import React from 'react';

import Button from '@liquidweb-dev/undercurrent/Button';
import ShieldCheckIcon from '@liquidweb-dev/undercurrent/icons/lucide/ShieldCheck';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';
import FancyHighlight from 'components/standard/FancyHighlight';
import RestrictionPaper from 'components/standard/Restrictions/RestrictionPaper';
import RestrictionWrapper from 'components/standard/Restrictions/RestrictionWrapper';

/**
 * @param {import('@liquidweb-dev/undercurrent/Stack').StackProps} props
 */
const RestrictionEnvironmentError = ({ sx, ...rest }) => {
	return (
		<RestrictionWrapper
			sx={combineSx(
				({ vars }) => ({
					background: `linear-gradient(165deg, ${vars.palette.uc.bg.main} 10.48%, ${vars.palette.uc.highlight.bg.weak} 55.27%, #E3E1FD 115.69%)`,
				}),
				sx,
			)}
			{...rest}
		>
			<RestrictionPaper>
				<FancyHighlight
					sx={({ vars }) => ({
						display: 'flex',
						gap: 100,
						alignItems: 'center',
						width: 'fit-content',
						color: vars.palette.uc.highlight.text.main,
					})}
				>
					<ShieldCheckIcon sx={{ width: '20px', height: '20px' }} />
					<Typography variant="title-sm">403 Forbidden</Typography>
				</FancyHighlight>

				<Typography variant="body-md" sx={{ fontWeight: 500 }}>
					You are not authorized to view this content
				</Typography>

				<Button
					component="a"
					href="https://my.liquidweb.com"
					variant="secondary"
					sx={{ width: 'fit-content' }}
					size="large"
				>
					Return home
				</Button>
			</RestrictionPaper>
		</RestrictionWrapper>
	);
};

export default RestrictionEnvironmentError;
